import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Row,
  Typography,
  Modal,
  Breadcrumb,
  message,
} from 'antd';
import SearchHeader from '../../Common/SearchHeader';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRazorPayOrder,
  getEventBookingByOrderId,
  clearRazorpayItems,
  nextSummary,
  resetSummary,
  checkCouponValidity,
  clearCart,
  previousSummary,
} from '../../../Redux/slices/cartSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as RedTick } from '../../../Assets/red-tick.svg';
import { returnModalHTML } from '../../../utils/utilHtml';

import { getEventById } from '../../../Redux/slices/eventSlice';
import './style.scss';
import {
  calculateTotal,
  dateFormatter,
  handleTicketCheckBox,
} from '../../../utils/helpers';
import Loading from 'react-fullscreen-loading';
import ModalFailureImg from '../../../Assets/modal_failure.svg';
import ModalSuccessImg from '../../../Assets/modal_success.svg';
import Category from './Category';
import Summary from './Summary';
import Payment from './Payment';
import { useMediaQuery } from 'react-responsive';
import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';
import CouponDialog from './CouponDialog';

const Cart = () => {
  const [initialLoading, setInitialLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState([]);
  const [ticketPrice, setTicketPrice] = useState(0);
  const [bookingPrice, setBookingPrice] = useState(0);

  const { id } = useParams();
  const {
    items,
    orderComplete,
    currentSummary,
    couponId,
    couponDiscount,
    couponApplied,
    isFreeEvent,
  } = useSelector((state) => state.cart);

  const [messageApi, contextHolder] = message.useMessage();
  const [showLoading, setShowLoading] = useState(false);
  const [freeLoading, setFreeLoading] = useState(false);
  const { razorpayOrderDetails, razorpayOrderTime } = useSelector(
    (state) => state.cart
  );
  const { eventDetails } = useSelector((state) => state.event);
  const [formValues, setFormValues] = useState({});
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    open: false,
    config: {},
  });
  const navigate = useNavigate();

  const [intervalId, setIntervalId] = useState(null);
  let retries = 0;

  const [tableData, setTableData] = useState([]);
  const [ticketData, setTicketData] = useState([]);
  useEffect(() => {
    dispatch(getEventById({ id }));
  }, [id]);

  useEffect(() => {
    if (orderComplete) {
      setShowLoading(false);
      dispatch(clearRazorpayItems());
      if (isFreeEvent) {
        setTimeout(() => {
          setOpenModal({
            open: true,
            config: {
              subHeading: 'SUCCESS',
              heading: 'Ticket Successfully Booked!',
              desc: "Congratulations! Your ticket(s) to the event have been successfully booked, and your payment has been received. We're thrilled to welcome you to the event! Get ready for an unforgettable experience. See you there! 🎟️✨",
              img: <img src={ModalSuccessImg} alt="failure" />,
              continueRoute: '/tickets',
            },
          });
          // eslint-disable-next-line react-hooks/exhaustive-deps
          retries = 0;
          if (intervalId) clearInterval(intervalId);
        }, 7500);
      } else {
        setOpenModal({
          open: true,
          config: {
            subHeading: 'SUCCESS',
            heading: 'Ticket Successfully Booked!',
            desc: "Congratulations! Your ticket(s) to the event have been successfully booked, and your payment has been received. We're thrilled to welcome you to the event! Get ready for an unforgettable experience. See you there! 🎟️✨",
            img: <img src={ModalSuccessImg} alt="failure" />,
            continueRoute: '/tickets',
          },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        retries = 0;
        if (intervalId) clearInterval(intervalId);
      }
    }
  }, [orderComplete]);
  useEffect(() => {
    const newTableData = [];
    let totalTicketPrice = 0;
    const ticketData = [];
    checkedItems.forEach((item) => {
      const ticket = items?.tickets?.find((ticket) => ticket.id === item);
      ticketData.push({
        ticket: ticket.id,
        qty: ticket.selectedQuantity ?? 0,
      });
      if (ticket) {
        totalTicketPrice += ticket.price * ticket.selectedQuantity;
        newTableData.push({
          item: (
            <div>
              <div>{ticket.title}</div>
              <div className="summary-time">
                {dateFormatter(items?.startDate, items?.endDate)}
              </div>
            </div>
          ),
          qty: ticket.selectedQuantity ?? 0,
          total: ticket.price * ticket.selectedQuantity,
          totalInString: `₹${ticket.price * ticket.selectedQuantity}`,
        });
      }
    });

    newTableData.push({
      item: 'Booking Fee',
      total: (items.bookingPrice * totalTicketPrice) / 100,
      totalInString: `₹${(items.bookingPrice * totalTicketPrice) / 100}`,
    });

    if (couponApplied) {
      newTableData.push({
        item: 'Coupon Discount',
        total: couponDiscount,
        totalInString: `-₹${couponDiscount}`,
      });
    }

    setTicketData(ticketData);
    setTableData(newTableData);
    setTicketPrice(totalTicketPrice);
    setBookingPrice((items.bookingPrice * totalTicketPrice) / 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedItems, items?.tickets, couponApplied]);

  useEffect(() => {
    if (showLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [showLoading]);

  const onFinish = async (values) => {
    const formattedValues = {
      name: values.name,
      phone: values.phone,
      email: values.email,
      tickets: [],
      questions: [],
    };

    Object.keys(values).forEach((key) => {
      if (key.startsWith('ticket[')) {
        const index = parseInt(key.match(/\d+/)[0]);
        const field = key.split('.')[1];

        if (!formattedValues.tickets[index]) {
          formattedValues.tickets[index] = {};
        }
        formattedValues.tickets[index][field] = values[key];
      } else if (key.startsWith('question[')) {
        const index = key.match(/question\[(.*?)\]/)[1];

        if (!formattedValues.questions[index]) {
          formattedValues.questions.push({
            questionId: index,
            answer:
              typeof values[key] == 'string' ? [values[key]] : values[key],
          });
        }
      }
    });

    setFormValues(formattedValues);

    const attendees = [
      {
        name: formattedValues.name,
        phone: formattedValues.phone,
        email: formattedValues.email,
      },
    ];

    if (formattedValues.tickets) {
      formattedValues.tickets.forEach((ticket) => {
        attendees.push({
          name: ticket.name,
          phone: ticket.phone,
          email: ticket.email,
        });
      });
    }

    const formData = {
      userDetails: {
        name: formattedValues.name,
        phone: formattedValues.phone,
        email: formattedValues.email,
      },
      tickets: [...ticketData],
      attendees: [...attendees],
      answers: [...formattedValues.questions],
      paymentMethod: 'gateway',
      amount: calculateTotal(tableData),
      payment: {
        ticketAmount: ticketPrice,
        bookingAmount: bookingPrice,
        transactionId: '',
        coupon: couponId,
        discountAmount: couponDiscount,
      },
    };

    const resp = await dispatch(
      getRazorPayOrder({
        id: items._id,
        body: formData,
        messageApi,
        navigate,
        setOpenModal,
        dispatch,
        setFreeLoading,
      })
    );

    if (!resp.payload.success) {
      setFreeLoading(false);
      window.alert(resp.payload.error);
    }
  };

  const onValidateCoupon = async (code) => {
    if (!code) {
      window.alert('Enter Coupon code');
    } else
      dispatch(
        checkCouponValidity({
          params: {
            eventId: items._id,
            amount: ticketPrice + bookingPrice,
          },
          code,
        })
      );
  };

  useEffect(() => {
    dispatch(clearRazorpayItems());
    dispatch(clearCart());
    setInitialLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadScript = (src) =>
    new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        console.log('razorpay loaded successfully');
        resolve(true);
      };
      script.onerror = () => {
        console.log('error in loading razorpay');
        resolve(false);
      };
      document.body.appendChild(script);
    });

  const handleSuccessRazorpayResponse = (response) => {
    setShowLoading(true);
    let intervalId = setInterval(() => {
      if (retries > 3) {
        setShowLoading(false);
        setFreeLoading(false);
        dispatch(clearRazorpayItems());
        // eslint-disable-next-line react-hooks/exhaustive-deps
        retries = 0;
        if (intervalId) clearInterval(intervalId);
        setOpenModal({
          open: true,
          config: {
            subHeading: 'FAILURE',
            heading: 'Booking Error 🚫',
            desc: 'Oops! It seems there was an issue processing your ticket booking or payment. No worries, any deducted amount will be refunded within 3 to 5 business days. Kindly retry the booking. Please feel free to reach out to us for any assistance.',
            img: <img src={ModalFailureImg} alt="failure" />,
            continueRoute: '/',
          },
        });
        return;
      }
      dispatch(getEventBookingByOrderId({ id: response.razorpay_order_id }));
      retries++;
    }, 5000);
    setIntervalId(intervalId);
  };

  const handleLoadRazorpay = async () => {
    loadScript('https://checkout.razorpay.com/v1/checkout.js').then((res) => {
      if (!res) {
        console.log('Razorpay SDK failed to load. Are you online?');
        return;
      }
      if (razorpayOrderDetails.amount > 0) {
        const options = {
          key: razorpayOrderDetails.rzpKey,
          amount: razorpayOrderDetails.amount,
          name: `Student Tribe - ${items.title}`,
          order_id: razorpayOrderDetails.id,
          prefill: {
            name: formValues.name,
            contact: formValues.phone,
            email: formValues.email,
          },
          handler: handleSuccessRazorpayResponse,
          modal: {
            confirm_close: true,
          },
          theme: { color: '#CC202E' },
          // send_sms_hash: true,
        };

        const rzp1 = new window.Razorpay(options);

        // To get payment id in case of failed transaction.
        rzp1.on('payment.failed', (response) => {
          console.log('payment.failed', response);
        });

        rzp1.open();
      }
    });
  };

  useEffect(() => {
    if (initialLoading && razorpayOrderDetails?.id) {
      handleLoadRazorpay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [razorpayOrderTime]);
  const subSections = [
    {
      name: 'category',
      title: 'Category',
    },
    {
      name: 'summary',
      title: 'Order Summary',
    },
    {
      name: 'ticketDetails',
      title: 'Ticket Details & Payment Method',
    },
  ];
  const handleNext = () => {
    if (!checkedItems.length > 0) return;
    dispatch(nextSummary());
  };
  const handlePrevious = () => {
    if (currentSummary > 0) {
      dispatch(previousSummary());
    } else {
      navigate(-1);
    }
  };

  const isMobile = useMediaQuery({ maxWidth: 600 });
  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      {contextHolder}
      <SearchHeader styleClass="header" showSearchBar={true} />

      <div className="payment-body-wrapper">
        <div className="event-main-details-container">
          <div className="event-main-detail-header">
            {isMobile && (
              <div className="event-back-button" onClick={handlePrevious}>
                <ArrowLeftOutlined />
              </div>
            )}
            <div className="event-title">{items.title}</div>
            {isMobile && (
              <div className="event-close-button" onClick={() => navigate(-1)}>
                <CloseOutlined />
              </div>
            )}
            <div className="event-location-text">
              {items.location.type === 'virtual'
                ? 'Virtual Event'
                : items.location.city}{' '}
              ({dateFormatter(items?.startDate, items?.endDate)})
            </div>
          </div>
          <Row className="event-detail-lower-header">
            {!isMobile ? (
              subSections.map(({ name, title }, index) => (
                <Col
                  key={`${title}-${index}`}
                  md={8}
                  className={`summary-individual-section-header ${
                    index === 1 && 'middle-section'
                  }`}
                >
                  {/* <Divider typee="vertical" className="section-divider" /> */}
                  {currentSummary === index && (
                    <Typography className="current-summary-text">
                      Current
                    </Typography>
                  )}
                  {currentSummary > index && (
                    <Typography className="complete-summary-text">
                      Complete
                    </Typography>
                  )}
                  <div className="justify-between align-center">
                    <Typography className="ticket-detail-section">
                      {index + 1}. {title}
                    </Typography>
                    {currentSummary > index && <RedTick />}
                  </div>
                </Col>
              ))
            ) : (
              <div className="mobile-breadcrumb-container">
                {' '}
                <Breadcrumb
                  separator=">"
                  items={[
                    {
                      title: (
                        <div className="d-flex align-center">
                          <Typography
                            className={`bread-crumb-number ${
                              currentSummary >= 0 && 'bread-crumb-number-active'
                            }`}
                          >
                            1
                          </Typography>
                          <Typography
                            className={`bread-crumb-text ${
                              currentSummary >= 0 && 'bread-crumb-text-active'
                            }`}
                          >
                            Category
                          </Typography>
                        </div>
                      ),
                    },
                    {
                      title: (
                        <div className="d-flex align-center">
                          <Typography
                            className={`bread-crumb-number ${
                              currentSummary >= 1 && 'bread-crumb-number-active'
                            }`}
                          >
                            2
                          </Typography>
                          <Typography
                            className={`bread-crumb-text ${
                              currentSummary >= 1 && 'bread-crumb-text-active'
                            }`}
                          >
                            Order summary
                          </Typography>
                        </div>
                      ),
                    },
                    {
                      title: (
                        <div className="d-flex align-center">
                          <Typography
                            className={`bread-crumb-number ${
                              currentSummary >= 2 && 'bread-crumb-number-active'
                            }`}
                          >
                            3
                          </Typography>
                          <Typography
                            className={`bread-crumb-text ${
                              currentSummary >= 2 && 'bread-crumb-text-active'
                            }`}
                          >
                            Ticket Details
                          </Typography>
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            )}
          </Row>
          <div className="event-location-text-mobile">
            {items.location.type === 'virtual'
              ? 'Virtual Event'
              : items.location.city}{' '}
            ({dateFormatter(items?.startDate, items?.endDate)})
          </div>
        </div>
        {currentSummary === 0 && (
          <Category
            items={items}
            handleTicketCheckBox={handleTicketCheckBox}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            ticketData={ticketData}
            setTicketData={setTicketData}
          />
        )}
        {currentSummary === 1 && (
          <Summary
            checkedItems={checkedItems}
            tableData={tableData}
            onValidateCoupon={onValidateCoupon}
          />
        )}
        {currentSummary === 2 && (
          <Payment
            form={form}
            onFinish={onFinish}
            tickets={ticketData}
            questions={eventDetails.questions}
            freeLoading={freeLoading}
          />
        )}

        {!isMobile && (
          <div className="cart-booking-action-container">
            <Button onClick={handlePrevious} className="cancel-btn">
              Back
            </Button>
            {currentSummary < 2 && (
              <Button
                onClick={handleNext}
                disabled={!checkedItems.length > 0}
                className="button next-btn"
              >
                Next
              </Button>
            )}
          </div>
        )}

        {openModal?.open && (
          <Modal
            open={openModal?.open}
            centered
            onOk={() => setOpenModal(false)}
            closable={false}
            footer={null}
          >
            {returnModalHTML(openModal, navigate, isMobile)}
          </Modal>
        )}
      </div>

      <Loading
        loading={showLoading}
        background="#000000AA"
        loaderColor="#3498db"
      />
      {isMobile && currentSummary < 2 && (
        <div className="sticky-footer">
          <div className="cart-button" onClick={handleNext}>
            Next
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
